import { type FC } from "react";
import { Navigate } from "react-router-dom";

import { usePageRedirect } from "../hooks";
import { type Feature } from "../models";

interface RedirectContainer {
    children: React.ReactNode;
    feature: Feature;
}

export const RedirectContainer: FC<RedirectContainer> = ({ children, feature }) => {
    const redirect = usePageRedirect(feature);

    if (redirect) {
        return <Navigate to={redirect} />;
    }

    return children;
};
